import { Checkbox } from '@blueprintjs/core'
import React from 'react'
import ReactTable from 'react-table'
import checkboxHOC from 'react-table/lib/hoc/selectTable'
import { getSort } from '../utils'
import Spinner from './Spinner'

const Table = checkboxHOC(ReactTable)

const ReactTableBlueprintCheckbox = ({ checked, onClick, id, row }) => (
  <Checkbox checked={checked} onChange={e => onClick(id, e, row)} />
)

const CheckboxTable = ({ meta, onMetaChange, data, idKey, ...rest }) => {
  const guardedMeta = meta || {}
  return (
    <Table
      className="-striped"
      loadingText={<Spinner />}
      manual
      page={(guardedMeta.page && guardedMeta.page - 1) || 0}
      pages={guardedMeta.maxPages || 1}
      pageSize={guardedMeta.perPage || 10}
      pageSizeOptions={[10, 15, 30, 50]}
      sorted={getSort(guardedMeta.sort)}
      onPageChange={p => onMetaChange('page', p + 1)}
      onPageSizeChange={p => onMetaChange('perPage', p)}
      onSortedChange={sort => onMetaChange('sort', sort.map(s => `${s.id}.${s.desc ? 'desc' : 'asc'}`)[0])} // only support one sort for now
      selectType="checkbox"
      SelectInputComponent={ReactTableBlueprintCheckbox}
      SelectAllInputComponent={ReactTableBlueprintCheckbox}
      {...rest}
      data={data.map(entry => ({
        _id: entry[idKey || 'id'],
        ...entry
      }))}
    />
  )
}

export { CheckboxTable }
export default React.memo(CheckboxTable)
